import { FC } from "react";
import { IconProps } from "utils/interfaces";

export const Securities: FC<IconProps> = ({ color }) => {
  return (
    <svg
      width="62"
      height="62"
      viewBox="0 0 62 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4615 11.8C16.4615 10.527 16.9721 9.30606 17.8809 8.40589C18.7898 7.50571 20.0224 7 21.3077 7H41.1802L52 14.1424V43.8C52 45.073 51.4894 46.2939 50.5806 47.1941C49.6718 48.0943 48.4391 48.6 47.1538 48.6H45.5385V50.2C45.5385 51.473 45.0279 52.6939 44.1191 53.5941C43.2102 54.4943 41.9776 55 40.6923 55H14.8462C13.5609 55 12.3282 54.4943 11.4194 53.5941C10.5106 52.6939 10 51.473 10 50.2V18.2C10 16.927 10.5106 15.7061 11.4194 14.8059C12.3282 13.9057 13.5609 13.4 14.8462 13.4H16.4615V11.8ZM16.4615 16.6H14.8462C14.4177 16.6 14.0068 16.7686 13.7039 17.0686C13.401 17.3687 13.2308 17.7757 13.2308 18.2V50.2C13.2308 50.6243 13.401 51.0313 13.7039 51.3314C14.0068 51.6314 14.4177 51.8 14.8462 51.8H40.6923C41.1207 51.8 41.5316 51.6314 41.8346 51.3314C42.1375 51.0313 42.3077 50.6243 42.3077 50.2V48.6H21.3077C20.0224 48.6 18.7898 48.0943 17.8809 47.1941C16.9721 46.2939 16.4615 45.073 16.4615 43.8V16.6Z"
        fill={color}
      />
    </svg>
  );
};
